import styled from "styled-components/macro";

export const DoubleConentColumn = styled.div``;

export default styled.div`
  margin: 0 !important;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
`;
